import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Chip from '@mui/material/Chip'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Typography from '@mui/material/Typography'
import { marketingHref } from '../lib/origins'

// Premium is sold only in the mobile apps, so CTAs go to the marketing home store links. Not /pricing: it is disabled and would 404.

const GET_APP_HREF = marketingHref('/')

function upgradeCopy(feature: string): string {
  return `Start your 14-day free trial in the Recall app to unlock ${feature}. One subscription covers the app, the web, and the Chrome extension.`
}

export function PremiumChip() {
  return (
    <Chip
      label="Premium"
      size="small"
      sx={{
        bgcolor: 'primary.main',
        color: 'primary.contrastText',
        fontWeight: 600,
        fontSize: 11,
        letterSpacing: '0.04em',
        height: 20,
        '& .MuiChip-label': { px: 1 },
      }}
    />
  )
}

function GetPremiumButton() {
  return (
    <Button variant="contained" component="a" href={GET_APP_HREF} target="_blank" rel="noopener">
      Get Recall Premium
    </Button>
  )
}

export function UpgradeDialog({
  open,
  onClose,
  title,
  feature,
}: {
  open: boolean
  onClose: () => void
  title: string
  feature: string
}) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ fontWeight: 700 }}>{title}</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary">{upgradeCopy(feature)}</Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} color="inherit">Not now</Button>
        <GetPremiumButton />
      </DialogActions>
    </Dialog>
  )
}

export function UpgradeCard({ title, feature }: { title: string; feature: string }) {
  return (
    <Box
      sx={{
        border: '1px solid var(--border)',
        borderRadius: 'var(--r-lg)',
        background: 'var(--surface)',
        p: 4,
        textAlign: 'center',
        maxWidth: 520,
        mx: 'auto',
      }}
    >
      <Box sx={{ display: 'inline-flex', mb: 2 }}><PremiumChip /></Box>
      <Typography sx={{ fontFamily: 'var(--font-serif)', fontWeight: 500, fontSize: 24, mb: 1 }}>{title}</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>{upgradeCopy(feature)}</Typography>
      <GetPremiumButton />
    </Box>
  )
}
